import ApiClient from '@/helpers/api/api.helpers';
class CallLogs extends ApiClient {
  constructor() {
    super('contacts');
  }
}

export default new CallLogs();
